import {} from 'viem';
var PresetChainID;
(function (PresetChainID) {
    PresetChainID[PresetChainID["Mainnet"] = 1] = "Mainnet";
    PresetChainID[PresetChainID["Sepolia"] = 11155111] = "Sepolia";
})(PresetChainID || (PresetChainID = {}));
export const presetAddressBook = {
    1: {
        wrappedToken: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        USDT: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
        allowanceTarget: '0xFb4aA7E6299502b36490cD4f8005481E69B0bEE0',
        genericSwap: '0xa7e96Bf2735BD33750Bb504C3Cc63e3770668dd4',
        permit2: '0x000000000022d473030f116ddee9f6b43ac78ba3',
        smartOrderStrategy: '0x0E67fD506Db5C6199C5D2b2b54380DEB414E2431',
    },
    11155111: {
        wrappedToken: '0xfFf9976782d46CC05630D1f6eBAb18b2324d6B14',
        USDT: '0x63b26b83c6f38433B2b6a7214fC2c569a4F4069A',
        allowanceTarget: '0xFb4aA7E6299502b36490cD4f8005481E69B0bEE0',
        genericSwap: '0xac4F3817a726016fC8254119FC48bE838a21f17F',
        permit2: '0x000000000022d473030f116ddee9f6b43ac78ba3',
        smartOrderStrategy: '0x4D5ECA271ca6668804F02cedf3C423b824c3CfbC',
    },
};
export class AddressBook {
    wrappedToken;
    USDT;
    allowanceTarget;
    genericSwap;
    permit2;
    smartOrderStrategy;
    static selectByChainID(chainID) {
        return new AddressBook(presetAddressBook[chainID]);
    }
    constructor(props) {
        this.wrappedToken = props['wrappedToken'];
        this.USDT = props['USDT'];
        this.allowanceTarget = props['allowanceTarget'];
        this.genericSwap = props['genericSwap'];
        this.permit2 = props['permit2'];
        this.smartOrderStrategy = props['smartOrderStrategy'];
    }
}
//# sourceMappingURL=addressBook.js.map